module.exports = __webpack_public_path__ + "static/img/1.d9ac874.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/11/1.png
// module id = O0yg
// module chunks = 0